import css from 'styled-jsx/css';

export default css.global`/* Move down content because we have a fixed navbar that is 50px tall */

html {
  scroll-behavior: smooth;
}

body {
  /* padding-bottom: 20px; */
  font-family: "Raleway", sans-serif;
  margin: 0;
  padding: 0;
}

a {
  /* color: #fff; */
  text-decoration: none;
}

a:hover {
  /* color: #fff; */
  text-decoration: none;
}

/* //forms */

.form-control {
  box-shadow: none;
  border: 1px solid #bdbdbd;
  height: 42px;
  border-radius: 0;
}

label {
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
}

/* Helper Class */

.no-padding {
  padding: 0;
}

.mbt3em {
  margin-bottom: 3em;
}

.flex-row {
  display: flex;
}

.flex-center {
  align-items: center;
}

.centered-flex {
  display: flex;
  align-items: center;
}

.flex-centered-justified {
  justify-content: center !important;
}

.cicod-header {
  color: #bc1824 !important;
  font-size: 1.4em;
  margin-bottom: 25px;
}

.ci-title {
  font-size: 25px;
  color: #bc1824 !important;
  text-align: center;
  font-weight: 600;
  margin: 40px 0px 15px 0px;
}

.big-title p {
  font-size: 25px;
  color: #2f2c7d;
  font-weight: 300;
}

h3.inner-title {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 21px;
  /* identical to box height */
  color: #2d3093;
}

.mb-1 {
  margin-bottom: 0.25rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-3 {
  margin-bottom: 1rem;
}

.mb-4 {
  margin-bottom: 1.25rem;
}

.mb-5 {
  margin-bottom: 1.5rem;
}

.pr-2 {
  padding-right: 2rem;
}

/* End Helper Class */

#footer {
  background-color: #ffffff;
  padding: 3em;
  font-weight: 300;
}

#footer a {
  color: #4d4d4d;
  list-style: none;
  margin-bottom: 5px;
  font-weight: 500;
  cursor: pointer;
  font-size: 12px;
}

.footer-btm ul,
#footer ul {
  list-style: none;
  /* float: right; */
  padding: 0;
}

#footer ul li {
}

#footer .footer-cont h3 {
  color: #4d4d4d;
  font-weight: 600;
  font-size: 18px;
}

.footer-btm li {
  float: left;
  margin-right: 25px;
}

.footer-btm a {
  color: #4d4d4d;
}

.footer-btm {
  background-color: rgba(146, 146, 146, 0.05);
  padding: 1em;
  color: #6a6a6a;
  font-weight: 300;
}

a {
  color: #000000;
}

.border-red {
  border-color: #21714b;
}

.border-orange {
  border-color: #191363;
}

.border-blue {
  border-color: #f77f03;
}

.border-grey {
  border-color: #eee !important;
}

.cicod-red-grad,
.com-grad {
  /* Fallback  */
  background-color: red;
  /* Safari 4, Chrome 1-9, iOS 3.2-4.3, Android 2.1-3.0 */
  background-image: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#ab1824),
    to(#7d1615)
  );
  /* Safari 5.1, iOS 5.0-6.1, Chrome 10-25, Android 4.0-4.3 */
  background-image: -webkit-linear-gradient(left, #ab1824, #7d1615);
  /* Firefox 3.6 - 15 */
  background-image: -moz-linear-gradient(left, #ab1824, #7d1615);
  /* Opera 11.1 - 12 */
  background-image: -o-linear-gradient(left, #ab1824, #7d1615);
  /* Opera 15+, Chrome 25+, IE 10+, Firefox 16+, Safari 6.1+, iOS 7+, Android 4.4+ */
  background-image: linear-gradient(to right, #ab1824, #7d1615);
}

.cicod-blue-grad,
.ucg-grad {
  /* Fallback  */
  background-color: #0c4586;
  /* Safari 4, Chrome 1-9, iOS 3.2-4.3, Android 2.1-3.0 */
  background-image: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#0c4586),
    to(#1f114d)
  );
  /* Safari 5.1, iOS 5.0-6.1, Chrome 10-25, Android 4.0-4.3 */
  background-image: -webkit-linear-gradient(left, #0c4586, #1f114d);
  /* Firefox 3.6 - 15 */
  background-image: -moz-linear-gradient(left, #0c4586, #1f114d);
  /* Opera 11.1 - 12 */
  background-image: -o-linear-gradient(left, #0c4586, #1f114d);
  /* Opera 15+, Chrome 25+, IE 10+, Firefox 16+, Safari 6.1+, iOS 7+, Android 4.4+ */
  background-image: linear-gradient(to right, #0c4586, #1f114d);
}

.cicod-green-grad,
.wfm-grad {
  /* Fallback  */
  background-color: #9aaf18;
  /* Safari 4, Chrome 1-9, iOS 3.2-4.3, Android 2.1-3.0 */
  background-image: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#9aaf18),
    to(#718300)
  );
  /* Safari 5.1, iOS 5.0-6.1, Chrome 10-25, Android 4.0-4.3 */
  background-image: -webkit-linear-gradient(left, #9aaf18, #718300);
  /* Firefox 3.6 - 15 */
  background-image: -moz-linear-gradient(left, #9aaf18, #718300);
  /* Opera 11.1 - 12 */
  background-image: -o-linear-gradient(left, #9aaf18, #718300);
  /* Opera 15+, Chrome 25+, IE 10+, Firefox 16+, Safari 6.1+, iOS 7+, Android 4.4+ */
  background-image: linear-gradient(to right, #9aaf18, #718300);
}

.cicod-orange-grad,
.ims-grad {
  /* Fallback  */
  background-color: #e6821e;
  /* Safari 4, Chrome 1-9, iOS 3.2-4.3, Android 2.1-3.0 */
  background-image: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#e9bd20, #e6821e)
  );
  /* Safari 5.1, iOS 5.0-6.1, Chrome 10-25, Android 4.0-4.3 */
  background-image: -webkit-linear-gradient(left, #e9bd20, #e6821e);
  /* Firefox 3.6 - 15 */
  background-image: -moz-linear-gradient(left, #e9bd20, #e6821e);
  /* Opera 11.1 - 12 */
  background-image: -o-linear-gradient(left, #e9bd20, #e6821e);
  /* Opera 15+, Chrome 25+, IE 10+, Firefox 16+, Safari 6.1+, iOS 7+, Android 4.4+ */
  background-image: linear-gradient(to right, #e9bd20, #e6821e);
}

.merchant-grad {
  background: linear-gradient(90deg, #ab1824 23.18%, #ea861e 56.4%);
}

.map-grad {
  background: linear-gradient(90deg, #ab1824 23.18%, #21714b 56.4%);
}
.grad2 {
  background: -webkit-linear-gradient(bottom, #1f114d, #0c458a);
}

.grad3 {
  background: -webkit-linear-gradient(bottom, #771613, #af1824);
}

.row-grey {
  background: #eaf0f4 !important;
}

.row-grey-2 {
  background: #f6f6f6 !important;
}
.font-red {
  color: #bc1824 !important;
}

.font-yellow {
  color: #f9de58 !important;
}

.ft-ims {
  color: #e6821e;
}

.ft-ucg {
  color: #1c1956;
}

.ft-wfm {
  color: #718300;
}

.ft-com {
  color: #7d1615;
}

.bg-ims {
  background-color: #e6821e;
}

.bg-ucg {
  background-color: #1c1956;
}

.bg-wfm {
  background-color: #718300;
}

.bg-com {
  background-color: #7d1615;
}

.label-red {
  background: #f5c6cb;
  color: #c0272a;
}

.label-green {
  background: #c2eee2;
  color: #2eaf73;
}

.navy-blue-text {
  color: #21714b !important;
}

.bg-grey {
  background-color: #f2f2f2;
}

.p30 {
  padding: 30px;
}

.cicod-alert-danger {
  background: rgb(255, 224, 224);
  color: rgb(88, 25, 25);
  border: 1px solid rgba(250, 110, 110, 0.312);
}

.font-blue {
  color: #7d1615;
}
.font-red {
  color: #21714b;
}

/* user license */
.user-license-sect {
  padding: 1rem 0;
}
.user-license-sect > h4 {
  color: #2d3093;
  font-weight: bold;
  font-size: 1.5rem;
}

.user-license-sect .inner-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-license-sect .number-of-users p {
  margin: 0;
  font-size: 1.3rem;
  color: #474747;
}

.user-license-sect .number-of-users p:first-child {
  font-weight: 600;
}

.user-license-sect .increment {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-license-sect .increment input {
  height: 25px;
  width: 50px;
  margin: 0 1rem;
  text-align: center;
  border: 1px solid #ebebeb;
  color: #818181;
}

.user-license-sect .increment input:focus {
  outline: #474747;
}

.user-license-sect .increment-btn {
  font-size: 1.5rem;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border: none;
  background: none;
  font-weight: bold;
  outline: none;
}

.user-license-sect .increment-btn:hover {
  background: #ebebeb;
}

/*---- MOBILE----*/

@media only screen and (max-width: 450px) {
}

/*---- TABLET ----*/

@media only screen and (max-width: 850px) and (min-width: 450px) {
  .ticker {
    display: none;
  }
}

.flex-wrap {
  display: flex;
  flex-flow: wrap;
}

.align-self-center {
  align-self: center;
}

.animation-blink {
  animation: blink 4s ease-in-out infinite;
}

@keyframes blink {
  /* 0% {
    opacity: 1;
  } */
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.password-toggler {
  position: relative;
}

.password-toggler .pwd-toogler {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
  color: gray;
}

.cicod-link {
  font-weight: 500;
}

.cicod-link:hover {
  text-decoration: underline;
}

.cicod-link--red,
.cicod-text--red,
.cicod-link--red:focus,
.cicod-text--red:focus {
  color: #b1272c;
}

.cicod-link--blue,
.cicod-text--blue {
  color: #035e35 !important;
}

.cicod-link--red:hover {
  color: #9c2126;
}

.cicod-link--blue:hover {
  color: #035e35;
}

.cicod-bold {
  font-weight: bold;
}

.main-component.with-padding {
  padding-top: 80px;
}
`